import __var_0__ from '@stdlib/utils/define-read-only-property';
import __var_1__ from '@stdlib/stats/base/dists/lognormal/cdf';
import __var_2__ from '@stdlib/stats/base/dists/lognormal/ctor';
import __var_3__ from '@stdlib/stats/base/dists/lognormal/entropy';
import __var_4__ from '@stdlib/stats/base/dists/lognormal/kurtosis';
import __var_5__ from '@stdlib/stats/base/dists/lognormal/logpdf';
import __var_6__ from '@stdlib/stats/base/dists/lognormal/mean';
import __var_7__ from '@stdlib/stats/base/dists/lognormal/median';
import __var_8__ from '@stdlib/stats/base/dists/lognormal/mode';
import __var_9__ from '@stdlib/stats/base/dists/lognormal/pdf';
import __var_10__ from '@stdlib/stats/base/dists/lognormal/quantile';
import __var_11__ from '@stdlib/stats/base/dists/lognormal/skewness';
import __var_12__ from '@stdlib/stats/base/dists/lognormal/stdev';
import __var_13__ from '@stdlib/stats/base/dists/lognormal/variance';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/*
* When adding modules to the namespace, ensure that they are added in alphabetical order according to module name.
*/

// MODULES //
var setReadOnly = __var_0__;


// MAIN //

/**
* Top-level namespace.
*
* @namespace lognormal
*/
var lognormal = {};

/**
* @name cdf
* @memberof lognormal
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/lognormal/cdf}
*/
setReadOnly( lognormal, 'cdf', __var_1__);

/**
* @name LogNormal
* @memberof lognormal
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/lognormal/ctor}
*/
setReadOnly( lognormal, 'LogNormal', __var_2__);

/**
* @name entropy
* @memberof lognormal
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/lognormal/entropy}
*/
setReadOnly( lognormal, 'entropy', __var_3__);

/**
* @name kurtosis
* @memberof lognormal
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/lognormal/kurtosis}
*/
setReadOnly( lognormal, 'kurtosis', __var_4__);

/**
* @name logpdf
* @memberof lognormal
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/lognormal/logpdf}
*/
setReadOnly( lognormal, 'logpdf', __var_5__);

/**
* @name mean
* @memberof lognormal
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/lognormal/mean}
*/
setReadOnly( lognormal, 'mean', __var_6__);

/**
* @name median
* @memberof lognormal
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/lognormal/median}
*/
setReadOnly( lognormal, 'median', __var_7__);

/**
* @name mode
* @memberof lognormal
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/lognormal/mode}
*/
setReadOnly( lognormal, 'mode', __var_8__);

/**
* @name pdf
* @memberof lognormal
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/lognormal/pdf}
*/
setReadOnly( lognormal, 'pdf', __var_9__);

/**
* @name quantile
* @memberof lognormal
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/lognormal/quantile}
*/
setReadOnly( lognormal, 'quantile', __var_10__);

/**
* @name skewness
* @memberof lognormal
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/lognormal/skewness}
*/
setReadOnly( lognormal, 'skewness', __var_11__);

/**
* @name stdev
* @memberof lognormal
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/lognormal/stdev}
*/
setReadOnly( lognormal, 'stdev', __var_12__);

/**
* @name variance
* @memberof lognormal
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/lognormal/variance}
*/
setReadOnly( lognormal, 'variance', __var_13__);


// EXPORTS //
export default lognormal;

export { __var_1__ as cdf, __var_2__ as LogNormal, __var_3__ as entropy, __var_4__ as kurtosis, __var_5__ as logpdf, __var_6__ as mean, __var_7__ as median, __var_8__ as mode, __var_9__ as pdf, __var_10__ as quantile, __var_11__ as skewness, __var_12__ as stdev, __var_13__ as variance};